/** Typed send helpers over any `TableDriver` (DESIGN-server §3.2 c→s messages). */
import { clientMessageTypes } from '@spades/shared';
import type { TableDriver } from './TableDriver';
import type { Bid, CardId, IntentName, SeatIndex, TableOptions } from './types-local';

export const INTENT_NAMES: readonly IntentName[] = clientMessageTypes;

export const NIL: Bid = { kind: 'nil' };
export const BLIND_NIL: Bid = { kind: 'blindNil' };
export const tricks = (n: number): Bid => ({ kind: 'tricks', n });

export function makeIntents(driver: Pick<TableDriver, 'send'>) {
  return {
    sit: (seat?: SeatIndex) => driver.send('sit', seat === undefined ? {} : { seat }),
    standUp: () => driver.send('standUp', {}),
    setRules: (rules: TableOptions) => driver.send('setRules', { rules }),
    start: () => driver.send('start', {}),
    peek: () => driver.send('peek', {}),
    bid: (bid: Bid) => driver.send('bid', { bid }),
    bidTricks: (n: number) => driver.send('bid', { bid: tricks(n) }),
    nil: () => driver.send('bid', { bid: NIL }),
    blindNil: () => driver.send('bid', { bid: BLIND_NIL }),
    lockCard: (card: CardId | null, slam?: boolean) =>
      driver.send('lockCard', slam === undefined ? { card } : { card, slam }),
    play: (card: CardId, slam?: 0 | 1 | 2 | 3) => driver.send('play', slam === undefined ? { card } : { card, slam }),
    timeBank: () => driver.send('timeBank', {}),
    resync: (sinceSeq: number) => driver.send('resync', { sinceSeq }),
    rematchVote: (choice: 'rematch' | 'money' | 'leave') => driver.send('rematchVote', { choice }),
    emote: (id: string) => driver.send('emote', { id }),
    addBot: (seat: SeatIndex) => driver.send('addBot', { seat }),
    kickBot: (seat: SeatIndex) => driver.send('kickBot', { seat }),
  };
}
export type IntentApi = ReturnType<typeof makeIntents>;
